<div class=" mt-4">
  <!-- <h3 class="mb-4">Exam Registered Students</h3> -->
  <div class="row">
    <!-- Regular Section -->
    <!-- <div class="col-xxl-6 col-md-12 card mb-5 shadow-sm">
      <div class="card-header bg-primary text-white">
        <h5 class="card-title mb-0 text-white">EAF Regular Registrations</h5>
      </div>
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-hover table-bordered mb-0 text-center align-middle">
            <thead class="table-light">
              <tr>
                <th rowspan="2" class="text-start ps-4 align-middle">Year & Semester</th>
                <th [attr.colspan]="allSections.length + 1" class="text-center bg-light">Payment Success</th>
                <th [attr.colspan]="allSections.length + 1" class="text-center">Payment Fail</th>
                <th rowspan="2" class="bg-light fw-bold align-middle">Total</th>
              </tr>
              <tr>

                <th *ngFor="let sec of allSections" class="text-center text-muted fw-normal bg-light">{{sec}}</th>
                <th class="text-center fw-bold bg-light">Total</th>
 
                <th *ngFor="let sec of allSections" class="text-center text-muted fw-normal">{{sec}}</th>
                <th class="text-center fw-bold">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of regularData">
                <td class="text-start ps-4 fw-medium text-nowrap">{{ row.year }} Year - {{ row.semester }} Semester</td>
                

                <td *ngFor="let sec of allSections" class="bg-light bg-opacity-50">
                  <a *ngIf="row.successBySection[sec].length > 0; else emptyTmpl" href="javascript:void(0)" class="text-success text-decoration-none fw-medium"
                     (click)="openModal('Regular | Year ' + row.year + ' Sem ' + row.semester + ' | Sec ' + sec + ' - Success', row.successBySection[sec])">
                    {{ row.successBySection[sec].length }}
                  </a>
                </td>
                <td class="bg-light">
                  <a *ngIf="row.successList.length > 0; else emptyTmpl" href="javascript:void(0)" class="text-success text-decoration-none fw-bold fs-6"
                     (click)="openModal('Regular | Year ' + row.year + ' Sem ' + row.semester + ' - Total Success', row.successList)">
                    {{ row.successList.length }}
                  </a>
                </td>
  

                <td *ngFor="let sec of allSections">
                  <a *ngIf="row.failBySection[sec].length > 0; else emptyTmpl" href="javascript:void(0)" class="text-danger text-decoration-none fw-medium"
                     (click)="openModal('Regular | Year ' + row.year + ' Sem ' + row.semester + ' | Sec ' + sec + ' - Fail', row.failBySection[sec])">
                    {{ row.failBySection[sec].length }}
                  </a>
                </td>
                <td>
                  <a *ngIf="row.failList.length > 0; else emptyTmpl" href="javascript:void(0)" class="text-danger text-decoration-none fw-bold fs-6"
                     (click)="openModal('Regular | Year ' + row.year + ' Sem ' + row.semester + ' - Total Fail', row.failList)">
                    {{ row.failList.length }}
                  </a>
                </td>
  

                <td class="bg-light">
                  <a *ngIf="row.totalList.length > 0; else emptyTmpl" href="javascript:void(0)" class="text-primary text-decoration-none fw-bold fs-6"
                     (click)="openModal('Regular | Year ' + row.year + ' Sem ' + row.semester + ' - Total', row.totalList)">
                    {{ row.totalList.length }}
                  </a>
                </td>
              </tr>
              <tr *ngIf="regularData.length === 0">
                <td [attr.colspan]="(allSections.length * 2) + 4" class="text-muted py-4">No regular students found.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div> -->

  <!-- Supplementary Section -->
    <div class="col-xxl-12 col-md-12 card mb-5 shadow-sm">
      <div class="card-header bg-secondary text-white py-1">
        <h5 class="card-title mb-0 text-white">EAF Supplementary Registrations</h5>
      </div>
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-hover table-bordered mb-0 text-center align-middle">
            <thead class="table-light">
              <tr>
                <th rowspan="2" class="text-start ps-4 align-middle">Year & Semester</th>
                <th [attr.colspan]="allSections.length + 1" class="text-center bg-light">Payment Success</th>
                <th [attr.colspan]="allSections.length + 1" class="text-center">Payment Fail</th>
                <th rowspan="2" class="bg-light fw-bold align-middle">Total</th>
              </tr>
              <tr>
                <!-- Success sections -->
                <th *ngFor="let sec of allSections" class="text-center text-muted fw-normal bg-light">{{sec}}</th>
                <th class="text-center fw-bold bg-light">Total</th>
                <!-- Fail sections -->
                <th *ngFor="let sec of allSections" class="text-center text-muted fw-normal">{{sec}}</th>
                <th class="text-center fw-bold">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of suppleData">
                <td class="text-start ps-4 fw-medium text-nowrap">{{ row.year }} Year - {{ row.semester }} Semester</td>
                
                <!-- Payment Success logic -->
                <td *ngFor="let sec of allSections" class="bg-light bg-opacity-50">
                  <a *ngIf="row.successBySection[sec].length > 0; else emptyTmpl" href="javascript:void(0)" class="text-success text-decoration-none fw-medium"
                     (click)="openModal('Supplementary | Year ' + row.year + ' Sem ' + row.semester + ' | Sec ' + sec + ' - Success', row.successBySection[sec])">
                    {{ row.successBySection[sec].length }}
                  </a>
                </td>
                <td class="bg-light">
                  <a *ngIf="row.successList.length > 0; else emptyTmpl" href="javascript:void(0)" class="text-success text-decoration-none fw-bold fs-6"
                     (click)="openModal('Supplementary | Year ' + row.year + ' Sem ' + row.semester + ' - Total Success', row.successList)">
                    {{ row.successList.length }}
                  </a>
                </td>
  
                <!-- Payment Fail logic -->
                <td *ngFor="let sec of allSections">
                  <a *ngIf="row.failBySection[sec].length > 0; else emptyTmpl" href="javascript:void(0)" class="text-danger text-decoration-none fw-medium"
                     (click)="openModal('Supplementary | Year ' + row.year + ' Sem ' + row.semester + ' | Sec ' + sec + ' - Fail', row.failBySection[sec])">
                    {{ row.failBySection[sec].length }}
                  </a>
                </td>
                <td>
                  <a *ngIf="row.failList.length > 0; else emptyTmpl" href="javascript:void(0)" class="text-danger text-decoration-none fw-bold fs-6"
                     (click)="openModal('Supplementary | Year ' + row.year + ' Sem ' + row.semester + ' - Total Fail', row.failList)">
                    {{ row.failList.length }}
                  </a>
                </td>
  
                <!-- Total row logic -->
                <td class="bg-light">
                  <a *ngIf="row.totalList.length > 0; else emptyTmpl" href="javascript:void(0)" class="text-secondary text-decoration-none fw-bold fs-6"
                     (click)="openModal('Supplementary | Year ' + row.year + ' Sem ' + row.semester + ' - Total', row.totalList)">
                    {{ row.totalList.length }}
                  </a>
                </td>
              </tr>
              <tr *ngIf="suppleData.length === 0">
                <td [attr.colspan]="(allSections.length * 2) + 4" class="text-muted py-4">No supplementary students found.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>

</div>

<ng-template #emptyTmpl>
  <span class="text-muted">-</span>
</ng-template>

<!-- Modal -->
<div *ngIf="showModal" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content shadow">
      <div class="modal-header bg-light">
        <h5 class="modal-title">{{ modalTitle }} ({{ selectedStudents.length }})</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body p-0">
        <div class="table-responsive" *ngIf="selectedStudents.length > 0; else noData">
          <table class="table table-hover table-striped mb-0 text-sm">
            <thead class="table-dark sticky-top">
              <tr>
                <th>S.No</th>
                <th>Hall Ticket No</th>
                <th>Student Name</th>
                <!-- <th>Student ID</th> -->
                <!-- <th>Year</th>
                <th>Semester</th>
                <th>Section</th> -->
                <!-- <th>Amount Paid(₹)</th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let student of selectedStudents; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ student.htNo }}</td>
                <td>{{ student.stName | titlecase }}</td>
                <!-- <td>{{ student.studentId }}</td> -->
                <!-- <td>{{ student.year }}</td>
                <td>{{ student.semester }}</td>
                <td>{{ student.section || 'N/A' }}</td> -->
                <!-- <td>{{ student.paidFees }}</td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #noData>
          <div class="p-4 text-center text-muted">
            <i class="bi bi-info-circle display-4"></i>
            <p class="mt-2 text-sm">No students found in this category.</p>
          </div>
        </ng-template>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary text-sm" (click)="closeModal()">Close</button>
      </div>
    </div>
  </div>
</div>
